import { CurrencyOption, getCurrencyOptions } from '@invoice-simple/common';
export type { CurrencyOption };

const currencyOptions = getCurrencyOptions();
export default currencyOptions;
